import { c as _c } from "react/compiler-runtime";
import { ActionMenu, ActionMenuItem, Checkbox, FormInput, Hint, Popover } from '@systemeio/ui';
import { activateLecture, duplicateLecture, removeLecture, updateLecture } from 'modules/courses/courses/curriculum/api/lecture-api';
import { CourseCurriculumInterface } from 'modules/courses/courses/curriculum/types/curriculum-interface';
import { EditLectureErrorsInterface, EditLectureInterface, LectureInterface } from 'modules/courses/courses/curriculum/types/lecture-interface';
import { nonDraggableProps } from 'modules/courses/courses/curriculum/utils/non-draggable-props';
import { useRouter } from 'next/router';
import React, { memo, useState } from 'react';
import Confirmation from 'shared/components/confirmation-modal';
import EditModal from 'shared/components/edit-modal';
import { ActionMenuLinkItem } from 'shared/components/table/components/action-menu-link-item';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { fetchWithFieldErrors } from 'shared/utils/fetch-with-errors';
import { KeyedMutator } from 'swr';
import { getCourseLectureAssignmentUrl } from '../../../../assignments/utils/get-course-lecture-assignment-url';
import { getCourseLectureEmailUrl } from '../../utils/get-course-lecture-email-url';
import { LectureEmailAction } from './lecture-email-action';
import { QuestionMarkIcon } from '@systemeio/ui/icons';
import { getPageEditorUrl } from 'shared/utils/get-page-editor-url';
interface LectureActionsProps {
  lecture: LectureInterface;
  mutate: KeyedMutator<CourseCurriculumInterface>;
  moduleId: number;
}
const defaultErrors: EditLectureErrorsInterface = {
  fields: {
    name: '',
    delayBeforePreviousLecture: ''
  }
};
function LectureActions(t0) {
  const $ = _c(172);
  const {
    lecture,
    mutate,
    moduleId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const router = useRouter();
  const {
    courseId
  } = router.query;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher: postFetcher
  } = useFetch(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.delete
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      method: RequestMethodsEnum.put
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    fetcher: putFetcher
  } = useFetch(t3);
  const {
    revalidateModules
  } = useRevalidateModules();
  const [isCreateEmailOpen, setIsCreateEmailOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isActivateOpen, setIsActivateOpen] = useState(false);
  const [isDuplicateOpen, setIsDuplicateOpen] = useState(false);
  const [editErrors, setEditErrors] = useState(defaultErrors);
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  let T0;
  let handleDuplicateLecture;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== courseId || $[4] !== deleteFetcher || $[5] !== editErrors || $[6] !== isActivateOpen || $[7] !== isCreateEmailOpen || $[8] !== isRemoveOpen || $[9] !== isSettingsOpen || $[10] !== lecture || $[11] !== moduleId || $[12] !== mutate || $[13] !== postFetcher || $[14] !== putFetcher || $[15] !== revalidateModules || $[16] !== t) {
    const caption = t("dashboard.course.lecture_title").toLowerCase();
    const lectureId = lecture.id;
    let t15;
    if ($[30] !== lecture.active || $[31] !== lecture.id || $[32] !== lectureId || $[33] !== moduleId || $[34] !== mutate || $[35] !== postFetcher) {
      t15 = async () => {
        const update = lecture.active ? "deactivate" : "activate";
        await activateLecture(update, lecture.id, postFetcher);
        await mutate(data => {
          if (data) {
            return {
              ...data,
              modules: data.modules.map(module => {
                if (module.id === moduleId) {
                  return {
                    ...module,
                    lectures: module.lectures.map(lecture_0 => {
                      if (lecture_0.id === lectureId) {
                        return {
                          ...lecture_0,
                          active: !lecture_0.active
                        };
                      }
                      return lecture_0;
                    })
                  };
                }
                return module;
              })
            };
          }
        }, false);
      };
      $[30] = lecture.active;
      $[31] = lecture.id;
      $[32] = lectureId;
      $[33] = moduleId;
      $[34] = mutate;
      $[35] = postFetcher;
      $[36] = t15;
    } else {
      t15 = $[36];
    }
    const handleActivateLecture = t15;
    let t16;
    if ($[37] !== lecture.id || $[38] !== moduleId || $[39] !== mutate || $[40] !== postFetcher || $[41] !== revalidateModules) {
      t16 = async () => {
        const response = await duplicateLecture(lecture.id, postFetcher);
        await mutate(data_0 => {
          if (data_0) {
            return {
              ...data_0,
              modules: data_0.modules.map(module_0 => {
                if (module_0.id === moduleId) {
                  const lectureIndex = module_0.lectures.findIndex(t17 => {
                    const {
                      id
                    } = t17;
                    return lecture.id === id;
                  });
                  const lectures = [...module_0.lectures];
                  lectures.splice(lectureIndex + 1, 0, {
                    ...response
                  });
                  return {
                    ...module_0,
                    lectures
                  };
                }
                return module_0;
              })
            };
          }
        }, false);
        await revalidateModules([RequestModuleEnum.MembershipCourseLecture]);
      };
      $[37] = lecture.id;
      $[38] = moduleId;
      $[39] = mutate;
      $[40] = postFetcher;
      $[41] = revalidateModules;
      $[42] = t16;
    } else {
      t16 = $[42];
    }
    handleDuplicateLecture = t16;
    let t17;
    if ($[43] !== deleteFetcher || $[44] !== lectureId || $[45] !== moduleId || $[46] !== mutate || $[47] !== revalidateModules) {
      t17 = async () => {
        await removeLecture(lectureId, deleteFetcher);
        await mutate(data_1 => {
          if (data_1) {
            return {
              ...data_1,
              modules: data_1.modules.map(module_1 => {
                if (module_1.id === moduleId) {
                  return {
                    ...module_1,
                    lectures: module_1.lectures.filter(lecture_1 => lecture_1.id !== lectureId)
                  };
                }
                return module_1;
              })
            };
          }
        }, false);
        await revalidateModules([RequestModuleEnum.MembershipCourseLecture]);
      };
      $[43] = deleteFetcher;
      $[44] = lectureId;
      $[45] = moduleId;
      $[46] = mutate;
      $[47] = revalidateModules;
      $[48] = t17;
    } else {
      t17 = $[48];
    }
    const handleRemoveLecture = t17;
    let t18;
    if ($[49] !== lectureId || $[50] !== moduleId || $[51] !== mutate || $[52] !== putFetcher || $[53] !== revalidateModules) {
      t18 = async data_2 => {
        await fetchWithFieldErrors(async () => {
          const response_0 = await updateLecture(lectureId, data_2, putFetcher);
          await mutate(data_3 => {
            if (data_3) {
              return {
                ...data_3,
                modules: data_3.modules.map(module_2 => {
                  if (module_2.id === moduleId) {
                    return {
                      ...module_2,
                      lectures: module_2.lectures.map(lecture_2 => {
                        if (lecture_2.id === lectureId) {
                          return response_0;
                        }
                        return lecture_2;
                      })
                    };
                  }
                  return module_2;
                })
              };
            }
          }, false);
        }, setEditErrors);
        await revalidateModules([RequestModuleEnum.MembershipCourseLecture]);
      };
      $[49] = lectureId;
      $[50] = moduleId;
      $[51] = mutate;
      $[52] = putFetcher;
      $[53] = revalidateModules;
      $[54] = t18;
    } else {
      t18 = $[54];
    }
    const handleEditLecture = t18;
    t14 = "flex items-center justify-end";
    t9 = nonDraggableProps;
    let t19;
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = {
        "data-test": "module-lecture-actions"
      };
      $[55] = t19;
    } else {
      t19 = $[55];
    }
    let t20;
    if ($[56] !== lecture.active || $[57] !== t) {
      t20 = lecture.active ? t("dashboard.actions.title.deactivate") : t("dashboard.actions.title.activate");
      $[56] = lecture.active;
      $[57] = t;
      $[58] = t20;
    } else {
      t20 = $[58];
    }
    let t21;
    let t22;
    if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = () => {
        setIsActivateOpen(true);
      };
      t22 = {
        "data-test": "module-lecture-action-status"
      };
      $[59] = t21;
      $[60] = t22;
    } else {
      t21 = $[59];
      t22 = $[60];
    }
    let t23;
    if ($[61] !== t20) {
      t23 = <ActionMenuItem key="action-activate" label={t20} onClick={t21} dataTestAttributes={t22} />;
      $[61] = t20;
      $[62] = t23;
    } else {
      t23 = $[62];
    }
    let t24;
    if ($[63] !== t) {
      t24 = t("dashboard.actions.title.edit");
      $[63] = t;
      $[64] = t24;
    } else {
      t24 = $[64];
    }
    let t25;
    if ($[65] !== lecture.pageId) {
      t25 = getPageEditorUrl(lecture.pageId);
      $[65] = lecture.pageId;
      $[66] = t25;
    } else {
      t25 = $[66];
    }
    let t26;
    if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
      t26 = {
        "data-test": "module-lecture-action-edit"
      };
      $[67] = t26;
    } else {
      t26 = $[67];
    }
    let t27;
    if ($[68] !== t24 || $[69] !== t25) {
      t27 = <ActionMenuLinkItem key="action-edit" label={t24} href={t25} dataTestAttributes={t26} />;
      $[68] = t24;
      $[69] = t25;
      $[70] = t27;
    } else {
      t27 = $[70];
    }
    let t28;
    if ($[71] !== t) {
      t28 = t("dashboard.actions.title.open");
      $[71] = t;
      $[72] = t28;
    } else {
      t28 = $[72];
    }
    let t29;
    if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
      t29 = {
        "data-test": "module-lecture-action-view"
      };
      $[73] = t29;
    } else {
      t29 = $[73];
    }
    let t30;
    if ($[74] !== lecture.loginLinkUrl || $[75] !== t28) {
      t30 = <ActionMenuLinkItem key="action-open" label={t28} href={lecture.loginLinkUrl} openInNew={true} dataTestAttributes={t29} />;
      $[74] = lecture.loginLinkUrl;
      $[75] = t28;
      $[76] = t30;
    } else {
      t30 = $[76];
    }
    let t31;
    if ($[77] !== t) {
      t31 = t("dashboard.actions.title.settings");
      $[77] = t;
      $[78] = t31;
    } else {
      t31 = $[78];
    }
    let t32;
    let t33;
    if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
      t32 = () => {
        setIsSettingsOpen(true);
      };
      t33 = {
        "data-test": "module-lecture-action-settings"
      };
      $[79] = t32;
      $[80] = t33;
    } else {
      t32 = $[79];
      t33 = $[80];
    }
    let t34;
    if ($[81] !== t31) {
      t34 = <ActionMenuItem key="action-settings" label={t31} onClick={t32} dataTestAttributes={t33} />;
      $[81] = t31;
      $[82] = t34;
    } else {
      t34 = $[82];
    }
    let t35;
    if ($[83] !== courseId || $[84] !== lecture.hasAssignmentSettings || $[85] !== lecture.id || $[86] !== t) {
      t35 = lecture.hasAssignmentSettings ? <ActionMenuLinkItem key="action-edit-assignment" label={t("dashboard.course.lecture.actions.edit_assignment")} isNext={true} href={getCourseLectureAssignmentUrl({
        courseId: Number(courseId as string),
        lectureId: lecture.id,
        hasAssignmentSettings: lecture.hasAssignmentSettings
      })} /> : <ActionMenuLinkItem key="action-create-assignment" label={t("dashboard.course.lecture.actions.create_assignment")} isNext={true} href={getCourseLectureAssignmentUrl({
        courseId: Number(courseId as string),
        lectureId: lecture.id,
        hasAssignmentSettings: lecture.hasAssignmentSettings
      })} />;
      $[83] = courseId;
      $[84] = lecture.hasAssignmentSettings;
      $[85] = lecture.id;
      $[86] = t;
      $[87] = t35;
    } else {
      t35 = $[87];
    }
    let t36;
    if ($[88] !== courseId || $[89] !== lecture.currentEmail?.id || $[90] !== lecture.id || $[91] !== t) {
      t36 = lecture.currentEmail?.id ? <ActionMenuLinkItem key="action-edit-drip" label={t("dashboard.course.lecture.actions.edit_drip")} isNext={true} href={getCourseLectureEmailUrl({
        courseId: Number(courseId as string),
        lectureId: lecture.id
      })} dataTestAttributes={{
        "data-test": "module-lecture-action-edit-drip"
      }} /> : <ActionMenuItem key="action-create-drip" label={<div className="[&>svg]:fill-brand-primary [&>svg]:main-transition-colors flex items-center gap-3">{t("dashboard.course.lecture.actions.create_drip")}<Popover label={t("dashboard.course.lecture.actions.create_drip_popover")} popoverClassName="w-[200px] sm:w-[300px] z-[99999]">{_temp}</Popover></div>} onClick={() => {
        setIsCreateEmailOpen(true);
      }} dataTestAttributes={{
        "data-test": "module-lecture-action-create-drip"
      }} />;
      $[88] = courseId;
      $[89] = lecture.currentEmail?.id;
      $[90] = lecture.id;
      $[91] = t;
      $[92] = t36;
    } else {
      t36 = $[92];
    }
    let t37;
    if ($[93] !== t) {
      t37 = t("dashboard.actions.title.duplicate");
      $[93] = t;
      $[94] = t37;
    } else {
      t37 = $[94];
    }
    let t38;
    let t39;
    if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
      t38 = () => {
        setIsDuplicateOpen(true);
      };
      t39 = {
        "data-test": "module-lecture-action-duplicate"
      };
      $[95] = t38;
      $[96] = t39;
    } else {
      t38 = $[95];
      t39 = $[96];
    }
    let t40;
    if ($[97] !== t37) {
      t40 = <ActionMenuItem key="action-duplicate" label={t37} onClick={t38} dataTestAttributes={t39} />;
      $[97] = t37;
      $[98] = t40;
    } else {
      t40 = $[98];
    }
    let t41;
    if ($[99] !== t) {
      t41 = t("dashboard.actions.title.remove");
      $[99] = t;
      $[100] = t41;
    } else {
      t41 = $[100];
    }
    let t42;
    let t43;
    if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
      t42 = () => {
        setIsRemoveOpen(true);
      };
      t43 = {
        "data-test": "module-lecture-action-remove"
      };
      $[101] = t42;
      $[102] = t43;
    } else {
      t42 = $[101];
      t43 = $[102];
    }
    let t44;
    if ($[103] !== t41) {
      t44 = <ActionMenuItem key="action-remove" label={t41} onClick={t42} dataTestAttributes={t43} />;
      $[103] = t41;
      $[104] = t44;
    } else {
      t44 = $[104];
    }
    if ($[105] !== t23 || $[106] !== t27 || $[107] !== t30 || $[108] !== t34 || $[109] !== t35 || $[110] !== t36 || $[111] !== t40 || $[112] !== t44) {
      t10 = <ActionMenu dataTestAttributes={t19} menuItems={[t23, t27, t30, t34, t35, t36, t40, t44]} />;
      $[105] = t23;
      $[106] = t27;
      $[107] = t30;
      $[108] = t34;
      $[109] = t35;
      $[110] = t36;
      $[111] = t40;
      $[112] = t44;
      $[113] = t10;
    } else {
      t10 = $[113];
    }
    let t45;
    if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
      t45 = () => setIsCreateEmailOpen(false);
      $[114] = t45;
    } else {
      t45 = $[114];
    }
    if ($[115] !== isCreateEmailOpen || $[116] !== lecture) {
      t11 = <LectureEmailAction lecture={lecture} isOpened={isCreateEmailOpen} onClose={t45} />;
      $[115] = isCreateEmailOpen;
      $[116] = lecture;
      $[117] = t11;
    } else {
      t11 = $[117];
    }
    let t46;
    if ($[118] !== t) {
      t46 = t("dashboard.course.lecture_edit_settings_title");
      $[118] = t;
      $[119] = t46;
    } else {
      t46 = $[119];
    }
    let t47;
    if ($[120] === Symbol.for("react.memo_cache_sentinel")) {
      t47 = () => {
        setIsSettingsOpen(false);
      };
      $[120] = t47;
    } else {
      t47 = $[120];
    }
    let t48;
    if ($[121] !== editErrors || $[122] !== lecture.id || $[123] !== t) {
      t48 = {
        field: "name",
        onRender: (value, onChange) => <FormInput value={value} key={`${lecture.id}-name`} onChange={e => onChange(e.target.value)} label={t("global.name")} error={editErrors.fields.name} />
      };
      $[121] = editErrors;
      $[122] = lecture.id;
      $[123] = t;
      $[124] = t48;
    } else {
      t48 = $[124];
    }
    let t49;
    if ($[125] !== editErrors || $[126] !== lecture.id || $[127] !== t) {
      t49 = {
        field: "delayBeforePreviousLecture",
        onRender: (value_0, onChange_0) => <FormInput value={value_0} key={`${lecture.id}-delayBeforePreviousLecture`} type="number" onChange={e_0 => onChange_0(parseInt(e_0.target.value))} label={<Hint label={t("dashboard.course.lecture_delay_title_tooltip")}>{t("dashboard.course.lecture_delay_title")}</Hint>} error={editErrors.fields.delayBeforePreviousLecture} />
      };
      $[125] = editErrors;
      $[126] = lecture.id;
      $[127] = t;
      $[128] = t49;
    } else {
      t49 = $[128];
    }
    let t50;
    if ($[129] !== moduleId || $[130] !== t) {
      t50 = {
        field: "showComments",
        onRender: (value_1, onChange_1) => <Checkbox key={`${moduleId}-showComments`} label={t("dashboard.course.show_comments_title")} value={value_1} onChange={onChange_1} />
      };
      $[129] = moduleId;
      $[130] = t;
      $[131] = t50;
    } else {
      t50 = $[131];
    }
    let t51;
    if ($[132] !== t48 || $[133] !== t49 || $[134] !== t50) {
      t51 = [t48, t49, t50];
      $[132] = t48;
      $[133] = t49;
      $[134] = t50;
      $[135] = t51;
    } else {
      t51 = $[135];
    }
    if ($[136] !== handleEditLecture || $[137] !== isSettingsOpen || $[138] !== lecture || $[139] !== t46 || $[140] !== t51) {
      t12 = <EditModal fullCaption={t46} opened={isSettingsOpen} onClose={t47} instance={lecture} editable={t51} onEdit={handleEditLecture} />;
      $[136] = handleEditLecture;
      $[137] = isSettingsOpen;
      $[138] = lecture;
      $[139] = t46;
      $[140] = t51;
      $[141] = t12;
    } else {
      t12 = $[141];
    }
    let t52;
    if ($[142] === Symbol.for("react.memo_cache_sentinel")) {
      t52 = () => setIsRemoveOpen(false);
      $[142] = t52;
    } else {
      t52 = $[142];
    }
    t13 = <Confirmation opened={isRemoveOpen} onClose={t52} onConfirm={handleRemoveLecture} confirmationText={t("dashboard.actions.remove_confirmation", {
      module: caption?.toLowerCase()
    })} toastCaption={t("dashboard.actions.removed", {
      module: caption
    })} />;
    T0 = Confirmation;
    t4 = isActivateOpen;
    if ($[143] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = () => setIsActivateOpen(false);
      $[143] = t5;
    } else {
      t5 = $[143];
    }
    t6 = handleActivateLecture;
    t7 = t("dashboard.actions.activate_confirmation", {
      activate: lecture.active ? t("global.deactivate").toLowerCase() : t("global.activate").toLowerCase(),
      module: caption?.toLowerCase()
    });
    t8 = t("dashboard.actions.activated", {
      module: caption,
      activated: lecture.active ? t("dashboard.actions.deactivated_caption").toLowerCase() : t("dashboard.actions.activated_caption").toLowerCase()
    });
    $[3] = courseId;
    $[4] = deleteFetcher;
    $[5] = editErrors;
    $[6] = isActivateOpen;
    $[7] = isCreateEmailOpen;
    $[8] = isRemoveOpen;
    $[9] = isSettingsOpen;
    $[10] = lecture;
    $[11] = moduleId;
    $[12] = mutate;
    $[13] = postFetcher;
    $[14] = putFetcher;
    $[15] = revalidateModules;
    $[16] = t;
    $[17] = T0;
    $[18] = handleDuplicateLecture;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    T0 = $[17];
    handleDuplicateLecture = $[18];
    t10 = $[19];
    t11 = $[20];
    t12 = $[21];
    t13 = $[22];
    t14 = $[23];
    t4 = $[24];
    t5 = $[25];
    t6 = $[26];
    t7 = $[27];
    t8 = $[28];
    t9 = $[29];
  }
  let t15;
  if ($[144] !== T0 || $[145] !== t4 || $[146] !== t5 || $[147] !== t6 || $[148] !== t7 || $[149] !== t8) {
    t15 = <T0 opened={t4} onClose={t5} onConfirm={t6} confirmationText={t7} toastCaption={t8} />;
    $[144] = T0;
    $[145] = t4;
    $[146] = t5;
    $[147] = t6;
    $[148] = t7;
    $[149] = t8;
    $[150] = t15;
  } else {
    t15 = $[150];
  }
  let t16;
  if ($[151] !== t) {
    t16 = t("dashboard.course.lecture_duplicate_title");
    $[151] = t;
    $[152] = t16;
  } else {
    t16 = $[152];
  }
  let t17;
  if ($[153] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => setIsDuplicateOpen(false);
    $[153] = t17;
  } else {
    t17 = $[153];
  }
  let t18;
  if ($[154] !== t) {
    t18 = t("dashboard.course.lecture_duplicated_title");
    $[154] = t;
    $[155] = t18;
  } else {
    t18 = $[155];
  }
  let t19;
  if ($[156] !== handleDuplicateLecture || $[157] !== isDuplicateOpen || $[158] !== t16 || $[159] !== t18) {
    t19 = <Confirmation confirmationText={t16} opened={isDuplicateOpen} onClose={t17} onConfirm={handleDuplicateLecture} toastCaption={t18} />;
    $[156] = handleDuplicateLecture;
    $[157] = isDuplicateOpen;
    $[158] = t16;
    $[159] = t18;
    $[160] = t19;
  } else {
    t19 = $[160];
  }
  let t20;
  if ($[161] !== t10 || $[162] !== t11 || $[163] !== t12 || $[164] !== t13 || $[165] !== t15 || $[166] !== t19 || $[167] !== t9) {
    t20 = <div {...t9}>{t10}{t11}{t12}{t13}{t15}{t19}</div>;
    $[161] = t10;
    $[162] = t11;
    $[163] = t12;
    $[164] = t13;
    $[165] = t15;
    $[166] = t19;
    $[167] = t9;
    $[168] = t20;
  } else {
    t20 = $[168];
  }
  let t21;
  if ($[169] !== t14 || $[170] !== t20) {
    t21 = <div className={t14}>{t20}</div>;
    $[169] = t14;
    $[170] = t20;
    $[171] = t21;
  } else {
    t21 = $[171];
  }
  return t21;
}
function _temp(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
export default memo(LectureActions);